import {createContext} from "react";

export const SignContractContext = createContext({
  user: null,
  organizationMembers: [],
  side: null,
  status: null,
  isMySignContract: false,
});
